import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { toast } from '@livable/saas-react-components';
import { Alert, Button, Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { isLivableStaffFromToken } from 'src/utils/isLivableStaffFromToken';
import useStyles from '../styles';
export const VoidRefundForm = observer(_ref => {
  let triggerRefresh = _ref.triggerRefresh,
    setTriggerRefresh = _ref.setTriggerRefresh;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    clicked = _useState2[0],
    setClicked = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    reason = _useState4[0],
    setReason = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    creditCompany = _useState6[0],
    setCreditCompany = _useState6[1];
  const canCreditCompany = isLivableStaffFromToken() && store.account.featureFlagsStore.getIsAccountSetupFeeEnabled && store.transaction.voidTransactionType === 'ACCOUNT_SETUP_FEE';
  const voidTransaction = async data => {
    const resp = await store.transaction.voidTransactionAsync.run(data);
    return resp;
  };
  const handleClick = () => setClicked(true);
  useEffect(() => {
    if (!clicked) return;
    toast('loading', {
      body: ['Void transaction in progress...']
    }); // ? i18n

    voidTransaction(_objectSpread({
      reason,
      transactionId: store.transaction.transactionId,
      hideFromResidentLedger: false
    }, canCreditCompany && creditCompany ? {
      creditCompany: true
    } : {})).then(resp => {
      if (resp && resp.isSuccessful) toast('success', {
        body: ['Transaction successfully voided']
      }); // ? i18n

      store.transaction.setRefundModalIsOpen(false);
      store.transaction.setVoidTransactionType('');
      store.transaction.setTransactionId('');
    }).then(() => {
      store.transaction.setUpdateData();
    }).finally(() => {
      setTriggerRefresh(!triggerRefresh);
      setClicked(false);
      setCreditCompany(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clicked]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "warning",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, store.transaction.voidTransactionType === 'CAPPED_UTILITY_CHARGE' ? t('resident_account.capped_utility_charge') : store.transaction.voidTransactionType === 'STATEMENT_CAP_CREDIT' ? t('resident_account.statement_cap_credit') : t('resident_account.void_info')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, store.transaction.voidTransactionType === 'CAPPED_UTILITY_CHARGE' ? t('resident_account.capped_utility_charge_desc') : store.transaction.voidTransactionType === 'STATEMENT_CAP_CREDIT' ? t('resident_account.statement_cap_credit_desc') : t('resident_account.void_info_desc'))), /*#__PURE__*/React.createElement("form", {
    id: "voidRefund"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formFields
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "reason",
    label: t('resident_account.reason'),
    name: "reason",
    onChange: e => {
      if (e.target.value.length <= 255) setReason(e.target.value);
    },
    maxRows: 10,
    multiline: true,
    rows: 2,
    type: "text",
    value: reason,
    variant: "outlined"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", reason.length, "/255)"), canCreditCompany && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: creditCompany,
      onChange: e => setCreditCompany(e.target.checked)
    }),
    label: t('resident_account.credit_company')
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('resident_account.credit_company_desc'))))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => store.transaction.setRefundModalIsOpen(false),
    'custom-attribute': '462-refund-modal'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: store.transaction.voidTransactionAsync.inProgress,
    onClick: handleClick,
    variant: "contained",
    'custom-attribute': '463-refund-modal'
  }, t('buttons.confirm'))))))));
});